import type { NextPage } from 'next'

import { Image } from 'src/components/atoms/Image'
import {
  FullWidthContainer,
  FullWidthContainerBackgroundColor
} from 'src/components/layouts/Container'
import { SanityPage } from 'src/components/layouts/Page'
import { CallToAction } from 'src/components/molecules/content/CallToAction'

import { dashboardPath } from 'src/config/paths'
import { NavigationContext } from 'src/types/account'

import { whyNativeTrees } from './helper'

const WhyNativeTreesPage: NextPage = () => {
  return (
    <SanityPage
      slug='why-native-trees'
      isFullWidth
      navigationContext={NavigationContext.Public}
    >
      {() => (
        <>
          <div className='w-full'>
            <Image
              src='/img/why-native-trees/why_native_trees.svg'
              fill
              alt='why native trees illustration'
              fillParent
            />
          </div>
          <FullWidthContainer
            backgroundColor={FullWidthContainerBackgroundColor.linen}
          >
            <div className='flex flex-wrap justify-center'>
              {whyNativeTrees.map((wnt, idx) => {
                return (
                  <div
                    key={idx}
                    className='w-4/5 md:w-1/3 lg:w-1/4 text-center p-3'
                  >
                    <div className='rounded-full pt-[100%] w-full border border-avatarBorderGrey overflow-hidden relative'>
                      <Image
                        src={wnt.image}
                        alt=''
                        fill
                        className='object-cover'
                      />
                    </div>
                    <div className='text-mostlyGreen font-displayAlt text-xl sm:text-2xl font-medium tracking-wide mt-3'>
                      {wnt.description}
                    </div>
                  </div>
                )
              })}
            </div>
          </FullWidthContainer>

          <FullWidthContainer
            backgroundColor={FullWidthContainerBackgroundColor.white}
          >
            <CallToAction
              heading='Plant • Gift • Donate'
              ctaText='Join us'
              subtitle='More native trees in the ground means greater biodiversity, cleaner waterways, thriving industries and stronger communities.'
              ctaLink={dashboardPath()}
            />
          </FullWidthContainer>
        </>
      )}
    </SanityPage>
  )
}

export default WhyNativeTreesPage
